<template>
<div class="modal" v-show="agencyModal">
<div class="modal__inner">
<form method="post" action="#" name="form-agency" @submit="submit">
<h2 class="modal__heading">代理店コードと募集人コードを入力ください。</h2>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-agency-code-01">代理店コード</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-agency-code-01" id="label-dummy-agency-code-01" class="form-text__input" maxlength="5" placeholder="半角で入力" v-model.trim="agencyCode">
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-recruiter-code-01">募集人コード</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-recruiter-code-01" id="label-dummy-recruiter-code-01" class="form-text__input" maxlength="8" placeholder="半角で入力" v-model.trim="agentCode">
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--align-bottom">
<div class="button-submit button-submit--type-02">
<button type="submit" class="button-submit__button" v-if="validateCode">
<span class="button-submit__button-inner">スタート</span>
<!-- /.button-submit__button --></button>
<button type="submit" class="button-submit__button" disabled v-else>
<span class="button-submit__button-inner">スタート</span>
<!-- /.button-submit__button --></button>
<!-- /.button-submit --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>
</form>
<!-- /.modal__inner --></div>
<div class="modal__overlay"></div>
<!-- /.modal --></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import URI from 'urijs';

    export default {
        name: 'Modal',
        computed: {
            ...mapGetters([
                'agencyModal',
                'agencyMode',
                'validateCode'
            ]),
            agencyCode: {
                get() {
                    return this.$store.getters.agencyCode;
                },
                set(value) {
                    this.changeAgencyCode(value);
                }
            },
            agentCode: {
                get() {
                    return this.$store.getters.agentCode;
                },
                set(value) {
                    this.changeAgentCode(value);
                }
            }
        },
        methods: {
            ...mapActions([
                'changeAgencyModal',
                'changeAgencyCode',
                'changeAgentCode',
                'changeAgencyMode'
            ]),
            sendTrackingCode() {
                const s = window.s;

                if (s) {
                    const agencyVariableString = this.agencyCode + '|' + this.agentCode;
                    let sCode;

                    s.pageName = '【RWD】公的保障試算ツール(STEP1)';
                    s.prop11 = agencyVariableString;
                    s.eVar11 = agencyVariableString;
                    s.events = 'event1';

                    sCode = s.t();

                    if (sCode) {
                        document.write(sCode);
                    }
                }
            },
            submit(event) {
                event.preventDefault();

                this.sendTrackingCode();
                this.changeAgencyModal(false);
                this.changeAgencyMode(true);
            }
        },
        created() {
            const uri = new URI(window.location.href);

            // 念のためノーマライズ
            uri.normalize();

            const query = uri.query(true);

            if (query.hasOwnProperty('teian') && query.teian[0] === '1') {
                // Step1 かつ未認証の場合のみ表示（他 Step では表示させない）
                if (this.$route.name === 'Step1' && !this.agencyMode) {
                    // 「代理店コード」クエリとクエリ値があるなら、自動入力
                    uri.hasQuery('olinavi_ag', (value, name) => {
                        const defined = uri.hasQuery(name);
                        let result = false;

                        if (defined && value) {
                            this.changeAgencyCode(value);
                            result = true;
                        }

                        return result;
                    });

                    // 「募集人コード」クエリとクエリ値があるなら、自動入力
                    uri.hasQuery('olinavi_sl', (value, name) => {
                        const defined = uri.hasQuery(name);
                        let result = false;

                        if (defined && value) {
                            this.changeAgentCode(value);
                            result = true;
                        }

                        return result;
                    });

                    this.changeAgencyModal(true);
                }
            } else {
                this.changeAgencyMode(false);
                this.changeAgencyModal(false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue